module.exports = __webpack_public_path__ + "img/cannon20ex_bg.f503314c.png";